// @flow

import styled from 'styled-components';
import { BRAND_PURPLE, BRAND_PURPLE_HOVER } from '../brand';
import { CheckmarkIcon as BaseCheckmarkIcon } from '@tectonics/features/jornada-sem-redirecionamento/pix-enrollment/screens/success-screen.styles';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 24px 16px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: auto 0;
  text-align: center;
`;

export const CheckmarkIcon = styled(BaseCheckmarkIcon)`
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  color: ${props => props.theme.colors.feedback.positive[500]};
`;

export const Title = styled.h1`
  margin-bottom: 12px;
  color: ${BRAND_PURPLE};
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
`;

export const Subtitle = styled.p`
  max-width: 280px;
  margin-bottom: 24px;
  color: ${props => props.theme.colors.neutral[600]};
  font-size: 13px;
  line-height: 1.5;
`;

export const SubmitButton = styled.button`
  display: block;
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 8px;
  color: ${props => props.theme.colors.neutral.white};
  background: ${BRAND_PURPLE};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: ${BRAND_PURPLE_HOVER};
  }
`;

export const ReturnLink = styled(SubmitButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
`;
